import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

export const STATS_EVENT = "rt:stats";

export const useStats = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/stats`);
        if (alive) setStats(data ?? null);
      } catch {
        if (alive) setStats(null);
      }
    };
    const onEvt = (e) => setStats(e.detail ?? null);
    load();
    const t = setInterval(load, 30000);
    window.addEventListener(STATS_EVENT, onEvt);
    return () => {
      alive = false;
      clearInterval(t);
      window.removeEventListener(STATS_EVENT, onEvt);
    };
  }, []);
  return stats;
};

export const useNow = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  return now;
};
